export enum ChannelType {
	Fax = 1,
	Email,
	Sms,
	Vocal,
	Chat,
}
